// Packages and components
import React from 'react';
import { Box } from 'grommet';
import SHDButton from '@ui/Button/SHDButton';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDModalContainer from '@ui/ModalContainer/SHDModalContainer';

// Helpers and utilities
import { usePointCapture } from '@hooks/useCapture';

// Types and interfaces
import type { EnableCameraModalProps } from './../schedule.d';

const EnableCameraModal: React.FC<EnableCameraModalProps> = ({
  capture,
  teamId,
  teamName,
  onUpdate,
  onClose,
}) => {
  // Hooks
  const { pointCapture, loading } = usePointCapture();

  // Handlers
  const handleEnableCamera = () => {
    pointCapture(teamId, capture).then((res) => {
      onUpdate && onUpdate(res);
    });
  };

  return (
    <>
      <SHDModalContainer isFirst>
        <SHDHeading
          level={3}
          formatCasing={false}
          margin={{ bottom: 'medium' }}
        >
          Enable camera for {teamName}?
        </SHDHeading>

        <Box direction="row" gap="small">
          <SHDButton
            primary
            label="Enable"
            busy={loading}
            onClick={() => handleEnableCamera()}
          />
          <SHDButton
            secondary
            label="Cancel"
            disabled={loading}
            onClick={() => onClose()}
          />
        </Box>
      </SHDModalContainer>
    </>
  );
};

export default EnableCameraModal;
